module.exports = __webpack_public_path__ + "img/smbc.5ff261b8.svg";